// extracted by css-extract-rspack-plugin
export default {"button":"GqBZs1t0BYQgk6JJ","default":"JacGkVC32RkSNzM4","primaryFlair":"n1Nn1f9PXQAYk8Dh","minimal":"iZoCWT8z2FUwjXxp"};